export const ExternalProgramCodes = {
    HESLP: 'HESLP'
} as const;

// Overrides the standard product-tag description when an application belongs to an external program.
const externalProgramProductLabels: Record<string, string> = {
    [ExternalProgramCodes.HESLP]: 'Home Energy Saver loan'
};

export function getExternalProgramProductLabel(externalProgram?: string): string | undefined {
    return externalProgram ? externalProgramProductLabels[externalProgram] : undefined;
}
